import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

export default function () {
  const masonryLayout = document.querySelector('.js-masonry-layout');

  if (!masonryLayout) {
    return false;
  }

  app.msnry = {};

  const init = function () {
    app.msnry.inst = new Masonry(masonryLayout, {
      itemSelector: '.masonry-item',
      columnWidth: '.masonry-sizer',
      percentPosition: true,
      transitionDuration: '.1s',
      gutter: 30,
    });
  };

  const destroy = function () {
    app.msnry.inst.destroy();
  };

  const add = function () {
    app.msnry.inst.addItems();

    setTimeout(function () {
      app.msnry.inst.reloadItems();
      app.msnry.inst.layout();
    }, 50);
  };

  app.msnry.destroy = destroy;
  app.msnry.init = init;
  app.msnry.add = add;

  app.msnry.rebuild = function () {
    destroy();

    setTimeout(function () {
      init();
    });
  };

  init();

  imagesLoaded( masonryLayout, function( instance ) {
    app.msnry.rebuild();
  });
};
